export const genders = [
  {label: 'זכר', value: 1},
  {label: 'נקבה', value: 2},
];
export const customerTypes = [
  {label: 'חברה', value: 1},
  {label: 'עירייה', value: 2},
  {label: 'מוסד', value: 3},
  {label: 'פרטי', value: 4},
  {label: 'קבוצה', value: 5},
];
export const customerStatus = [
  {label: 'פעיל', value: 1},
  {label: 'מוקפא', value: 2},
];
export const priceQuoteStatus = [
  {label: 'פתוחה', value: 1},
  {label: 'מוקפאת', value: 2},
  {label: 'הומרה להזמנה', value: 3},
];
export const priceQuoteCustomerStatus = [
  {label: 'טרם נשלח', value: 1},
  {label: 'ממתין לתגובה', value: 2},
  {label: 'אושר ע”י הלקוח', value: 3}
];
export const taskStatuses = [
  {label: 'פתוחה', value: 1},
  {label: 'סגורה', value: 2},
];
export const taskTypes = [
  {label: 'משימת ביקור בנכס', value: 1},
  {label: 'משימה כללית', value: 2},
];
export const maxPayments = [
  {label: '1', value: 1},
  {label: '2', value: 2},
  {label: '3', value: 3},
  {label: '4', value: 4},
  {label: '5', value: 5},
  {label: '6', value: 6},
  {label: '7', value: 7},
  {label: '8', value: 8},
  {label: '9', value: 9},
  {label: '10', value: 10},
  {label: '11', value: 11},
  {label: '12', value: 12},
  {label: '13', value: 13},
  {label: '14', value: 14},
  {label: '15', value: 15},
  {label: '16', value: 16},
  {label: '17', value: 17},
  {label: '18', value: 18},
  {label: '19', value: 19},
  {label: '20', value: 20},
  {label: '21', value: 21},
  {label: '22', value: 22},
  {label: '23', value: 23},
  {label: '24', value: 24},
  {label: '25', value: 25},
  {label: '26', value: 26},
  {label: '27', value: 27},
  {label: '28', value: 28},
  {label: '29', value: 29},
  {label: '30', value: 30},
  {label: '31', value: 31},
  {label: '32', value: 32},
  {label: '33', value: 33},
  {label: '34', value: 34},
  {label: '35', value: 35},
  {label: '36', value: 36},
];
export const docTypes = [
  {label: 'חשבונית מס קבלה', value: 320},
  {label: 'קבלה', value: 400},
];
export const shumaStatuses = [
  {label: 'בתהליך', value: 1},
  {label: 'נדחה', value: 3},
  {label: 'אושר', value: 4},
  {label: 'מוכן לשליחה', value: 5},
  {label: 'ממתין לבדיקה', value: 6},
  {label: 'ממתין לאישור סופי', value: 7},
  {label: 'הסתיים (ידני)', value: 8},
  {label: 'מוקפא', value: 9},
  {label: 'מבוטל', value: 10},
];
export const notificationStatusTypeOptions = [
  {label: 'בתהליך', value: 1},
  {label: 'כשלון', value: 2},
  {label: 'הצלחה', value: 3}
];